import Inbox from '@/pages/requests/InboxPage.vue'
import PaymentsDetailPage from '@/pages/requests/detailPages/RequestToPayDetailPage.vue'
// import PaymentsTrashPage from '@/pages/services/payments/CMTrashPage.vue'
// import PaymentsDraftPage from '@/pages/services/payments/CMDraftPage.vue'
import PaymentsDraftEditPage from '@/pages/services/payments/TDraftEdit.vue'
import PaymentsDraftCreatePage from '@/pages/services/payments/TDraftCreate.vue'
import PaymentsCreation from '@/pages/requests/creationPages/capsules/TPayments.vue'
import PaymentsPilotage from '@/pages/statistics/StatisticsPage.vue'
// import PaymentsDebtorList from '@/pages/services/payments/CMDebtorList.vue'
import PaymentsDebtorList from '@/pages/requests/ContactDebtorList.vue'
// import PaymentsContactDebtorList from '@/pages/services/payments/CMContactDebtorList.vue'
import PaymentsNegotiation from '@/pages/requests/negotiationPages/CMTransactionEdit.vue'

export default [
  {
    // path: '/payments/inbox/:showPreloader',
    path: '/inbox/:direction/:modeFilter',
    alias: ['/account/inbox/', '/payments/'],
    component: Inbox
  },
  {
    path: '/inbox/1',
    alias: ['/account/senbox/', '/sendbox/'],
    component: Inbox
  },
  /* {
    path: '/payments/sendbox/:tab',
    alias: ['/account/senbox/:tab', '/sendbox/:tab'],
    component: PaymentsSentboxPage
  }, */
  {
    path: '/payments/transaction-details/',
    alias: ['/account/transaction-details/', '/transaction-details/'],
    component: PaymentsDetailPage
  },
  // {
  //   path: '/payments/trash/',
  //   alias: ['/account/trash/', '/trash/'],
  //   component: PaymentsTrashPage
  // },
  // {
  //   path: '/payments/draft/',
  //   component: PaymentsDraftPage
  // },
  {
    path: '/payments/draft/edit/',
    component: PaymentsDraftEditPage
  },
  {
    path: '/payments/draft/create/',
    component: PaymentsDraftCreatePage
  },
  {
    path: '/payments/newPayments/',
    alias: ['/account/createPayments', '/createPayments/'],
    component: PaymentsCreation
  },
  {
    path: '/payments/debtorList/',
    alias: ['/account/createPayments/debtorList', '/createPayments/debtorList/'],
    component: PaymentsDebtorList
  },
  /* {
    path: '/payments/contactDebtorList/',
    alias: ['/account/createPayments/contactDebtorList', '/createPayments/contactDebtorList/'],
    component: PaymentsContactDebtorList
  }, */
  {
    path: '/payments/pilotage/',
    alias: ['/account/pilotage/', '/pilotage/'],
    component: PaymentsPilotage
  },
  {
    path: '/payments/negotiate/',
    component: PaymentsNegotiation
  }
]



// WEBPACK FOOTER //
// ./src/routes/services/payments.js